import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import AuthLayout from '../../layouts/AuthLayout'
import "aos/dist/aos.css";
import useAuthStore from '../../store/auth';
import { refresh, verifyAccount } from '../../adapters/authentication';

export default function VerifyEmail() {

    const user = useAuthStore((state) => state.user);
    const authToken = useAuthStore((state) => state.token);
    const [error, setError ] = useState('')
    const setAuth = useAuthStore((state) => state.setAuth);

    const params = useParams();
    const [verifyStatus, setVerifyStatus] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.token])


    async function verifyEmail() {
        await verifyAccount(user._id, params.token, authToken).then((res) => {
            if(res.status === 200 ) {
                setVerifyStatus(true);
                refresh(authToken).then((res) => {
                    if (res.status === 200) {
                        setAuth(res.data);
                    }
                });
                return navigate('/account')
            }else{
                setError('Invalid or expired token!');
                return navigate('/email-verification')
            }
        })
    }
  return (
      <AuthLayout title="Verify Email">
          {verifyStatus&& <div className="relative">
            <div className="mb-4 text-center font-semibold text-green-600 flex items-center justify-center w-full">
                <span className="animate__animated animate__bounceInDown animate__fast animate__repeat-1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-16 h-16">
                        <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                    </svg>
                </span>
            </div>
            <p className="mb-6 text-lg font-semibold text-center ">
                Email Verification Successful
            </p>
            <Link to="/account/dashboard" className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg ">
                Go To Dashboards
            </Link>
        </div>}

          {!verifyStatus && <div className="relative">
              <div className="mb-4 text-center font-semibold text-red-600 flex items-center justify-center w-full">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-16 h-16">
                      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
                  </svg>

              </div>
              <p className="mb-6 text-lg font-semibold text-center ">
                 { error ? error : 'Account Not Verified'}
              </p>
              {/* <Link to="/dashboard" className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg ">
                  Go To Dashboards
              </Link> */}
          </div>}
      </AuthLayout>
  )
}
